import { FC } from 'react';
import styled from 'styled-components';
import { createPortal } from 'react-dom';
import Badge, { BadgeInfo } from './Badge';

const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(100, 100, 100, 0.5);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
`;

const BackgroundButton = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
`;

const Modal = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    position: relative;
    width: 800px;
    min-height: 400px;
    background: ${color.grayscale[1000]};
    margin: 0 auto;
    margin-top: 10px;
    border-radius: 5px;
    z-index: 2;
    padding: 10px 20px;
  `;
});

const CloseButton = styled.button`
  display: inline-block;
  position: absolute;
  right: 16px;
  top: 5px;
  cursor: pointer;
`;

const Title = styled.h2(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.large};
    font-weight: ${type.weight.bold};
  `;
});

interface BadgeWindowProps {
  hideFunction: () => void;
  unlockedBadges: BadgeInfo[];
}

const BadgesWindow: FC<BadgeWindowProps> = ({ hideFunction, unlockedBadges }) => {
  const printBadges = unlockedBadges.map((badge) => {
    return <Badge badgeInfo={badge} />;
  });

  return createPortal(
    <Container>
      <BackgroundButton onClick={hideFunction} />

      <Modal>
        <Title>Your Badges</Title>

        <CloseButton onClick={hideFunction}>
          <i className="fa fa-times"></i>
        </CloseButton>

        <div className="badges_window_content">{printBadges}</div>
      </Modal>
    </Container>,
    document.body
  );
};

export default BadgesWindow;
